const style = {
  flex: "2 1 0"
};

export function AnimeSelectorContainer(props) {
  return (<>
    <div style={ style }>{ props.children }</div>
  </>);
}
